import type { CancellationPolicy } from '@/models/cancellationPolicy';
import { safeFormatClientDate, safeParseISO } from '../../../../shared/frontend-resources/src/util/datetime-fns';
import { isFuture, subDays } from 'date-fns';

export const noPayoutRuleHost = (fiftyPercentDeadline: number) =>
    `Ingen utbetaling dersom leietaker avbestiller mer enn ${fiftyPercentDeadline} dager før innsjekkingsdatoen.`;

export const fiftyPercentPayoutRuleHost = (fiftyPercentDeadline: number, noRefundDeadline: number) =>
    `50 % utbetaling ${noRefundDeadline}–${fiftyPercentDeadline} dager før innsjekkingsdatoen.`;

export const fullPayoutRuleHost = (noRefundDeadline: number) =>
    `100 % utbetaling dersom leietaker avbestiller mindre enn ${noRefundDeadline} dager før innsjekkingsdatoen.`;

export const fullRefundRuleTenant = (fiftyPercentDeadline: number) =>
    `Full refusjon hvis avbestillingen skjer mer enn ${fiftyPercentDeadline} dager før innsjekksdato.`;

export const fiftyPercentRefundRuleTenant = (fiftyPercentDeadline: number, noRefundDeadline: number) =>
    `50 % refusjon hvis avbestillingen skjer ${noRefundDeadline}–${fiftyPercentDeadline} dager før innsjekksdato.`;

export const noRefundRuleTenant = (noRefundDeadline: number) =>
    `Ingen refusjon hvis avbestillingen skjer mindre enn ${noRefundDeadline} dager før innsjekksdato.`;

export const fullRefundRuleHost = (fiftyPercentDeadline: number) =>
    `Leietaker får full refusjon hvis avbestillingen skjer mer enn ${fiftyPercentDeadline} dager før innsjekksdato.`;

export const fiftyPercentRefundRuleHost = (fiftyPercentDeadline: number, noRefundDeadline: number) =>
    `Leietaker får 50 % refusjon hvis avbestillingen skjer ${noRefundDeadline}–${fiftyPercentDeadline} dager før innsjekksdato.`;

export const noRefundRuleHost = (noRefundDeadline: number) =>
    `Leietaker får ingen refusjon hvis avbestillingen skjer mindre enn ${noRefundDeadline} dager før innsjekksdato.`;

export const getTestPolicy = () => {
    return {
        id: 'MODERATE',
        displayName: 'Moderat',
        fiftyPercentRefundDeadlineDays: 30,
        noRefundDeadlineDays: 14,
        paymentDeadlineDays: 30,
        isActive: true,
    } as CancellationPolicy;
};

export const getCurrentCancellationRule = (startDate: string, policy: CancellationPolicy): string | undefined => {
    const startDateAsDate = safeParseISO(startDate);
    if (!startDateAsDate) {
        return undefined;
    }

    const noRefundCutoff = subDays(startDateAsDate, policy.noRefundDeadlineDays);
    const fiftyPercentRefundCutoff = subDays(startDateAsDate, policy.fiftyPercentRefundDeadlineDays);
    if (isFuture(fiftyPercentRefundCutoff)) {
        return `Du får full refusjon av innbetalt beløp hvis avbestillingen skjer før ${safeFormatClientDate(fiftyPercentRefundCutoff)}.`;
    }
    if (isFuture(noRefundCutoff)) {
        return `Du får 50 % refusjon av innbetalt beløp hvis avbestillingen skjer før ${safeFormatClientDate(noRefundCutoff)}.`;
    }
    return 'Siden det er mindre enn X dager til oppholdet starter vil du ikke få refundert innbetalt beløp ved kansellering.';
};
